module.exports = __webpack_public_path__ + "static/img/banner.3999d678.jpg";